import { useSelector } from 'src/hooks/useSelector';

const useIsVisibleUserTest = (): boolean => {
    const vacancyView = useSelector((state) => state.vacancyView);
    return Boolean(vacancyView?.userTestId && !vacancyView.status.archived);
};

export default useIsVisibleUserTest;
